// removed by extract-text-webpack-plugin
module.exports = {"no-text-decoration":"no-text-decoration__1MrR2","slide":"slide__3K-Fk","top-section":"top-section__rIe0a","bottom-section":"bottom-section__3qStX","light":"light__3gsbG","dark":"dark__Vyjvo","slide-image":"slide-image__3UCvv","slide-elements":"slide-elements__X5BGs","name":"name__1BAc8","variant":"variant__29IrT","divider":"divider__2-7kY","time-remaining":"time-remaining__1o4pF","detail":"detail__31Lcb","arrow":"arrow__2ZQSS"};


//////////////////
// WEBPACK FOOTER
// ./components/raffle/styles/RaffleCarouselSlide.scss
// module id = LYBV
// module chunks = 1